import React, { useMemo } from 'react'
import { Card, PictureArea, Sold } from '@/modern/components/Card'
import PhotoSlider from '@/components/PhotoSlider'
import useUrl from '@/modern/hooks/useUrl'
import InfoAreaHorizontal from './InfoAreaHorizontal'
import InfoAreaVertical from './InfoAreaVertical'
import InfoAreaSmartLeadVertical from './InfoAreaSmartLeadVertical'
import InfoAreaSmartLeadHorizontal from './InfoAreaSmartLeadHorizontal'
import { PictureWrapper, CertifiedPurchase } from './style'
import StampView360 from '../Stamps/View360'
import StampSponsored from '../Stamps/Sponsored'
import { config } from 'config/config'
import {sendDataLayer} from 'utils/utils'

const VehicleCardFactory = ({
  id,
  model,
  make,
  version,
  price,
  year,
  travelledDistance,
  location,
  seller,
  href = '#',
  photos = [],
  attributes = [],
  stamps = {},
  hasFavoriteActions = false,
  isHorizontal = false,
  wasFavorited = false,
  excludeFavoriteKey = false,
  wasSold = false,
  type,
  oldAd,
  mediaZeroKm,
  advertisementLink,
  hideSponsoredTag = false,
  positionIndex
}) => {
  const canIUseParceiroSantander = () => {
    const valorFeiroes = Object.values(stamps.feiroes)
    const temAlgumFeirao = valorFeiroes.includes(true)
    return !temAlgumFeirao && stamps.sellerBadges
  }

  const photosWithImageRender = () => {
    return photos.map(
      photo => photo + config.searchResult.image.imageHandlerRender
    )
  }

  const { addOrigin, addOriginMediaZeroKm } = useUrl()

  const InfoAreaProps = {
    id,
    href: mediaZeroKm ? advertisementLink + addOriginMediaZeroKm(advertisementLink, mediaZeroKm) : href + addOrigin(href),
    model,
    make,
    version,
    price,
    year,
    travelledDistance,
    location,
    seller,
    attributes,
    hasFavoriteActions,
    wasFavorited,
    excludeFavoriteKey,
    stamps,
    canIUseParceiroSantander,
    type,
    wasSold
  }
  const { IsElegibleVehicleInspection, IsElegible360View } = oldAd

  const vehicleTitle = useMemo(() => {
    return `${make} ${model} ${version || ''} ${year || ''}`.replace(
      /  +/g,
      ' '
    )
  }, [make, model, version, year])

  const showSponsored = mediaZeroKm && !hideSponsoredTag

  const dispatchDataLayer = () => {
    if(mediaZeroKm){
      const newDatalayer = {...objDataLayer, search: {...objDataLayer.search, cardSelected: {positionIndex}}}
      sendDataLayer(newDatalayer,'selectedSmartLeadCard')
    }
  }

  const renderInfoArea = () => {
    const type = mediaZeroKm ? 'smartLead' : 'default'
    const axis = isHorizontal ? 'horizontal' : 'vertical'

    const infoAreaMap = {
      default: {
        horizontal: <InfoAreaHorizontal {...InfoAreaProps} oldAd={oldAd} />,
        vertical: <InfoAreaVertical {...InfoAreaProps} oldAd={oldAd} />,
      },
      smartLead: {
        horizontal: <InfoAreaSmartLeadHorizontal {...InfoAreaProps} dispatchDataLayer={dispatchDataLayer} />,
        vertical: <InfoAreaSmartLeadVertical {...InfoAreaProps} dispatchDataLayer={dispatchDataLayer}/>,
      },
    }

    return infoAreaMap[type][axis]
  }

  return (
    <Card isHorizontal={isHorizontal}>
      <PictureWrapper>
        <CertifiedPurchase
          shouldRender={IsElegibleVehicleInspection}
          invertedBorder
        />
        <PictureWrapper>
          {showSponsored && <StampSponsored />}
          {IsElegible360View && <StampView360 />}
          <PictureArea isHorizontal={isHorizontal}>
            {wasSold ? (
              <Sold />
            ) : (
              <PhotoSlider
                width={config.searchResult.image.width}
                height={config.searchResult.image.height}
                linkCarousel={InfoAreaProps.href}
                dispatchDataLayer={dispatchDataLayer}
                listPhotos={photosWithImageRender()}
                tag={{
                  title: vehicleTitle,
                  alt: vehicleTitle,
                }}
              />
            )}
          </PictureArea>
        </PictureWrapper>
      </PictureWrapper>

      {renderInfoArea()}
    </Card>
  )
}

export default VehicleCardFactory
